export type ReplySnapshot = { id: string; authorName: string; excerpt: string };
export default function ReplyPreview({
  reply,
  onCancel,
}: {
  reply: ReplySnapshot;
  onCancel: () => void;
}) {
  return (
    <div
      className="chat-reply-preview"
      role="group"
      aria-label={`Réponse à ${reply.authorName}`}
    >
      <div>
        <strong>Réponse à {reply.authorName}</strong>
        <p>{reply.excerpt}</p>
      </div>
      <button type="button" aria-label="Annuler la réponse" onClick={onCancel}>
        ×
      </button>
    </div>
  );
}
